import locationHoursData from '@/data/locationHours.json';

export function LocationHours() {
  return (
    <div className="bg-[#f5f5dc] py-8">
      <div className="container mx-auto px-4">
        <div className="max-w-md mx-auto text-center">
          <h3 className="text-xl font-bold text-[#8b4513] mb-6 tracking-wide">
            {locationHoursData.heading.toUpperCase()}
          </h3>
          
          {/* Map container placeholder */}
          <div className="bg-white border-2 border-[#d4b08a] mb-4 h-32 flex items-center justify-center text-gray-500 text-sm">
            <div>
              <p className="font-semibold text-[#8b4513]">
                {locationHoursData.address.street}
              </p>
              <p className="text-[#8b4513]">
                {locationHoursData.address.city}, {locationHoursData.address.state} {locationHoursData.address.zipCode}
              </p>
            </div>
          </div>
          
          {/* Hours */}
          <div className="space-y-2 text-sm">
            <div className="flex justify-center items-center gap-2">
              <span className="font-bold text-[#8b4513]">
                {locationHoursData.hours.weekdays.label}
              </span>
              <span className="text-[#8b4513]">
                {locationHoursData.hours.weekdays.time}
              </span>
            </div>
            <div className="flex justify-center items-center gap-2">
              <span className="font-bold text-[#8b4513]">
                {locationHoursData.hours.weekends.label}
              </span>
              <span className="text-[#8b4513]">
                {locationHoursData.hours.weekends.time}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}